var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import * as R from "ramda";
const getNotDisplayedCombinations = (annotation) => R.pipe(
  R.prop("title"),
  R.split(","),
  R.reduce((acc, dimension) => {
    const [dim, value] = dimension.split("=");
    const values = R.ifElse(
      R.test(/\((.*?)\)/g),
      R.pipe(
        R.match(/\((.*?)\)/g),
        R.head,
        R.replace(/[()]/g, ""),
        R.split("+")
      ),
      R.always("")
    )(value);
    return R.head(values) ? __spreadProps(__spreadValues({}, acc), { [dim]: values }) : acc;
  }, {})
)(annotation);
export {
  getNotDisplayedCombinations
};
